/* Imports */
import React from "react"
import { Flexbox, InputCheck } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const InputCheckPage = () => {
    const items = [
        {
            title: "Radio",
            content: (
                <Flexbox gap="m" wrap="wrap">
                    <InputCheck type="radio" id="radio-1" name="radio" label="Radio" />
                    <InputCheck type="radio" id="radio-2" name="radio" label="Radio" defaultChecked />

                    <InputCheck
                        type="radio"
                        id="radio-3"
                        name="radio-validation"
                        label="Radio"
                        validation="not-passed"
                    />
                    <InputCheck
                        type="radio"
                        id="radio-4"
                        name="radio-validation"
                        label="Radio"
                        validation="not-passed"
                        defaultChecked
                    />

                    <InputCheck type="radio" id="radio-5" name="radio-disabled" label="Radio" disabled />
                    <InputCheck type="radio" id="radio-6" name="radio-disabled" label="Radio" disabled defaultChecked />
                </Flexbox>
            ),
            code: '<InputCheck\n    type="radio"\n    id="radio-1"\n    name="radio"\n    label="Radio"\n/>\n<InputCheck\n    type="radio"\n    id="radio-2"\n    name="radio"\n    label="Radio"\n    defaultChecked\n/>\n\n<InputCheck\n    type="radio"\n    id="radio-3"\n    name="radio-validation"\n    label="Radio"\n    validation="not-passed"\n/>\n<InputCheck\n    type="radio"\n    id="radio-4"\n    name="radio-validation"\n    label="Radio"\n    validation="not-passed"\n    defaultChecked\n/>\n\n<InputCheck\n    type="radio"\n    id="radio-5"\n    name="radio-disabled"\n    label="Radio"\n    disabled\n/>\n    \n<InputCheck\n    type="radio"\n    id="radio-6"\n    name="radio-disabled"\n    label="Radio"\n    disabled\n    defaultChecked\n/>',
        },
        {
            title: "Checkbox",
            content: (
                <Flexbox gap="m" wrap="wrap">
                    <InputCheck type="checkbox" id="checkbox-1" name="checkbox" label="Checkbox" />
                    <InputCheck type="checkbox" id="checkbox-2" name="checkbox" label="Checkbox" defaultChecked />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-3"
                        name="checkbox-validation"
                        label="Checkbox"
                        validation="not-passed"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-4"
                        name="checkbox-validation"
                        label="Checkbox"
                        validation="not-passed"
                        defaultChecked
                    />

                    <InputCheck type="checkbox" id="checkbox-5" name="checkbox-disabled" label="Checkbox" disabled />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-6"
                        name="checkbox-disabled"
                        label="Checkbox"
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck\n    type="checkbox"\n    id="checkbox-1"\n    name="checkbox"\n    label="Checkbox"\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-2"\n    name="checkbox"\n    label="Checkbox"\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-3"\n    name="checkbox-validation"\n    label="Checkbox"\n    validation="not-passed"\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-4"\n    name="checkbox-validation"\n    label="Checkbox"\n    validation="not-passed"\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-5"\n    name="checkbox-disabled"\n    label="Checkbox"\n    disabled\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-6"\n    name="checkbox-disabled"\n    label="Checkbox"\n    disabled\n    defaultChecked\n/>',
        },
        {
            title: "Radio tile",
            content: (
                <Flexbox gap="xxs" direction="column">
                    <InputCheck type="radio" id="radio-tile-1" name="radio-tile" label="Radio" tile />
                    <InputCheck type="radio" id="radio-tile-2" name="radio-tile" label="Radio" tile defaultChecked />

                    <InputCheck
                        type="radio"
                        id="radio-tile-3"
                        name="radio-tile-validation"
                        label="Radio"
                        validation="not-passed"
                        tile
                    />
                    <InputCheck
                        type="radio"
                        id="radio-tile-4"
                        name="radio-tile-validation"
                        label="Radio"
                        validation="not-passed"
                        tile
                        defaultChecked
                    />

                    <InputCheck type="radio" id="radio-tile-5" name="radio-tile-disabled" label="Radio" tile disabled />
                    <InputCheck
                        type="radio"
                        id="radio-tile-6"
                        name="radio-tile-disabled"
                        label="Radio"
                        tile
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck\n    type="radio"\n    id="radio-tile-1"\n    name="radio-tile"\n    label="Radio"\n    tile\n/>\n<InputCheck\n    type="radio"\n    id="radio-tile-2"\n    name="radio-tile"\n    label="Radio"\n    tile\n    defaultChecked\n/>\n\n<InputCheck\n    type="radio"\n    id="radio-tile-3"\n    name="radio-tile-validation"\n    label="Radio"\n    validation="not-passed"\n    tile\n/>\n<InputCheck\n    type="radio"\n    id="radio-tile-4"\n    name="radio-tile-validation"\n    label="Radio"\n    validation="not-passed"\n    tile\n    defaultChecked\n/>\n\n<InputCheck\n    type="radio"\n    id="radio-tile-5"\n    name="radio-tile-disabled"\n    label="Radio"\n    tile\n    disabled\n/>\n<InputCheck\n    type="radio"\n    id="radio-tile-6"\n    name="radio-tile-disabled"\n    label="Radio"\n    tile\n    disabled\n    defaultChecked\n/>',
        },
        {
            title: "Checkbox tile",
            content: (
                <Flexbox gap="xxs" direction="column">
                    <InputCheck type="checkbox" id="checkbox-tile-1" name="checkbox-tile" label="Checkbox" tile />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-2"
                        name="checkbox-tile"
                        label="Checkbox"
                        tile
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-3"
                        name="checkbox-tile-validation"
                        label="Checkbox"
                        validation="not-passed"
                        tile
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-4"
                        name="checkbox-tile-validation"
                        label="Checkbox"
                        validation="not-passed"
                        tile
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-5"
                        name="checkbox-tile-disabled"
                        label="Checkbox"
                        tile
                        disabled
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-6"
                        name="checkbox-tile-disabled"
                        label="Checkbox"
                        tile
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck\n    type="checkbox"\n    id="checkbox-tile-1"\n    name="checkbox-tile"\n    label="Checkbox"\n    tile\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-tile-2"\n    name="checkbox-tile"\n    label="Checkbox"\n    tile\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-tile-3"\n    name="checkbox-tile-validation"\n    label="Checkbox"\n    validation="not-passed"\n    tile\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-tile-4"\n    name="checkbox-tile-validation"\n    label="Checkbox"\n    validation="not-passed"\n    tile\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-tile-5"\n    name="checkbox-tile-disabled"\n    label="Checkbox"\n    tile\n    disabled\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-tile-6"\n    name="checkbox-tile-disabled"\n    label="Checkbox"\n    tile\n    disabled\n    defaultChecked\n/>',
        },
        {
            title: "Toggle",
            content: (
                <Flexbox gap="m" wrap="wrap">
                    <InputCheck type="checkbox" id="checkbox-toggle-1" name="checkbox-toggle" label="Toggle" toggle />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-2"
                        name="checkbox-toggle"
                        label="Toggle"
                        toggle
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-3"
                        name="checkbox-toggle-validation"
                        label="Toggle"
                        validation="not-passed"
                        toggle
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-4"
                        name="checkbox-toggle-validation"
                        label="Toggle"
                        validation="not-passed"
                        toggle
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-5"
                        name="checkbox-toggle-disabled"
                        label="Toggle"
                        toggle
                        disabled
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-6"
                        name="checkbox-toggle-disabled"
                        label="Toggle"
                        toggle
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck\n    type="checkbox"\n    id="checkbox-toggle-1"\n    name="checkbox-toggle"\n    label="Toggle"\n    toggle\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-toggle-2"\n    name="checkbox-toggle"\n    label="Toggle"\n    toggle\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-toggle-3"\n    name="checkbox-toggle-validation"\n    label="Toggle"\n    validation="not-passed"\n    toggle\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-toggle-4"\n    name="checkbox-toggle-validation"\n    label="Toggle"\n    validation="not-passed"\n    toggle\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-toggle-5"\n    name="checkbox-toggle-disabled"\n    label="Toggle"\n    toggle\n    disabled\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-toggle-6"\n    name="checkbox-toggle-disabled"\n    label="Toggle"\n    toggle\n    disabled\n    defaultChecked\n/>',
        },
        {
            title: "Selector",
            content: (
                <Flexbox gap="m" wrap="wrap">
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-1"
                        name="checkbox-selector"
                        label="Selector"
                        selector
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-2"
                        name="checkbox-selector"
                        label="Selector"
                        selector
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-3"
                        name="checkbox-selector-validation"
                        label="Selector"
                        validation="not-passed"
                        selector
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-4"
                        name="checkbox-selector-validation"
                        label="Selector"
                        validation="not-passed"
                        selector
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-5"
                        name="checkbox-selector-disabled"
                        label="Selector"
                        selector
                        disabled
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-6"
                        name="checkbox-selector-disabled"
                        label="Selector"
                        selector
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck\n    type="checkbox"\n    id="checkbox-selector-1"\n    name="checkbox-selector"\n    label="Selector"\n    selector\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-selector-2"\n    name="checkbox-selector"\n    label="Selector"\n    selector\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-selector-3"\n    name="checkbox-selector-validation"\n    label="Selector"\n    validation="not-passed"\n    selector\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-selector-4"\n    name="checkbox-selector-validation"\n    label="Selector"\n    validation="not-passed"\n    selector\n    defaultChecked\n/>\n\n<InputCheck\n    type="checkbox"\n    id="checkbox-selector-5"\n    name="checkbox-selector-disabled"\n    label="Selector"\n    selector\n    disabled\n/>\n<InputCheck\n    type="checkbox"\n    id="checkbox-selector-6"\n    name="checkbox-selector-disabled"\n    label="Selector"\n    selector\n    disabled\n    defaultChecked\n/>',
        },
    ]

    const propsItems = [
        {
            name: "id",
            type: "String",
            example: "input",
            required: "Yes",
        },
        {
            name: "label",
            type: "String",
            example: "Radio",
            required: "Yes",
        },
        {
            name: "name",
            type: "String",
            example: "radio-group",
            required: "Yes",
        },
        {
            name: "type",
            type: "String",
            example: "checkbox",
            possible: '"radio" | "checkbox"',
            default: "radio",
        },
        {
            name: "tile",
            type: "Boolean",
        },
        {
            name: "toggle",
            type: "Boolean",
        },
        {
            name: "selector",
            type: "Boolean",
        },
        {
            name: "validation",
            type: "String",
            example: "not-passed",
            possible: commonProps.validationInput,
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default InputCheckPage
